import { useMemo } from "react";
import { jwtDecode } from "jwt-decode";

/* Same rule as server/src/services/projectCreator.js: the recorded creator,
   else — for projects older than that field — the "Project Owner" who is not
   the lead, else the lead. Used when the API does not send `creatorId`. */
export const deriveCreatorId = (projectData) => {
  if (!projectData) return "";
  if (projectData.creatorId) return String(projectData.creatorId);
  if (projectData.createdBy) return String(projectData.createdBy?._id || projectData.createdBy);

  const leadId = String(projectData.lead?._id || projectData.lead || "");
  const otherOwner = (projectData.contributors || []).find(
    (member) =>
      String(member?.role || "").toLowerCase() === "project owner" &&
      member?.employeeId &&
      String(member.employeeId) !== leadId
  );
  return otherOwner ? String(otherOwner.employeeId) : leadId;
};

/**
 * Whether the signed-in user created this project — the only person who may
 * change its settings.
 *
 * The server enforces this on every settings write; this hook only decides
 * what to show. `ready` is false until a project has loaded, so callers can
 * show a skeleton instead of flashing "no access".
 */
export default function useIsProjectCreator(projectData) {
  const creatorId = deriveCreatorId(projectData);

  return useMemo(() => {
    if (!creatorId) return { ready: false, isCreator: false, creatorId: "" };

    let userId = "";
    try {
      userId = jwtDecode(localStorage.getItem("accessToken") || "")?.id || "";
    } catch {
      userId = "";
    }
    return { ready: true, isCreator: Boolean(userId) && String(userId) === creatorId, creatorId };
  }, [creatorId]);
}
